import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appComponentValue]',
})
export class ComponentValueDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
